import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store'
import '@/components'
import '@babel/polyfill'
//import 'roboto-fontface/css/roboto/roboto-fontface.css'
//import '@fortawesome/fontawesome-free/css/all.css'
import './registerServiceWorker'



Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
